import { render, staticRenderFns } from "./customChart.vue?vue&type=template&id=a08f3038&scoped=true&"
import script from "./customChart.vue?vue&type=script&lang=js&"
export * from "./customChart.vue?vue&type=script&lang=js&"
import style0 from "./customChart.vue?vue&type=style&index=0&id=a08f3038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08f3038",
  null
  
)

export default component.exports